import { render, staticRenderFns } from "./Fulllist.vue?vue&type=template&id=ff09b7e4&"
import script from "./Fulllist.vue?vue&type=script&lang=js&"
export * from "./Fulllist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports